import PropTypes from "prop-types";
import { isNil } from "ramda";

import logo from "assets/images/common/logo-resizable.svg";

import { Root, Video, Content, Title, Logo } from "./styles";

const Hero = ({ items, isLoading }) => {
  const video = items?.[0];

  return (
    <Root>
      {!isLoading && !isNil(video) ? (
        <Video
          data-testid="hero-video"
          autoPlay
          muted
          playsInline
          disablePictureInPicture
          loop
          poster={video.previewPoster}
          onContextMenu={(e) => e.preventDefault()}
          src={video.previewVideo}
        />
      ) : null}
      <Content>
        <Logo src={logo} alt="JibJab" />
        <Title variant="h3">Stick Your Face In It!</Title>
      </Content>
    </Root>
  );
};

Hero.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      previewVideo: PropTypes.string,
      previewPoster: PropTypes.string,
    }),
  ),
  isLoading: PropTypes.bool,
};

export default Hero;
